import { NgModule } from "@angular/core";
import { MachineDetailsLayoutComponent } from "./machine-details-layout/machine-details-layout.component";
import { Routes, RouterModule, UrlSegment } from "@angular/router";
import { SharedModule } from "app/shared/shared.module";
import { FormsModule } from "@angular/forms";
import { MachineLocationComponent } from "./machine-location/machine-location.component";
import { AddToCartFooterComponent } from "./add-to-cart-footer/add-to-cart-footer.component";
import { MachineDetailsResolverService } from "./machine-details-resolver.service";
import { AzureMapsModule } from "@rubbl-azure-maps";
import { SearchResultsModule } from "@rubbl-search-results";
import { AddressPipe, CoreModule } from "@rubbl-core";
import { RubblSharedModule } from "@rubbl-shared";
import { CartModule } from "@rubbl-cart";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { InventoryModule } from "@rubbl-inventory";
import { MarketingModule } from "@rubbl-marketing";
import { AccountModule } from "@rubbl-account";
import { LayoutModule } from "@rubbl-layout";
import { MachineSpecsComponent } from "./machine-specs/machine-specs.component";
import { MachineReviewsComponent } from "./machine-reviews/machine-reviews.component";

const routes: Routes = [
  {
    component: MachineDetailsLayoutComponent,
    matcher: (url: UrlSegment[]) => {
      return { consumed: url };
    },
    resolve: {
      machine: MachineDetailsResolverService,
    },
    data: {
      doNotUpdateSeo: true,
    },
  },
];

@NgModule({
  declarations: [MachineDetailsLayoutComponent, MachineLocationComponent, AddToCartFooterComponent, MachineSpecsComponent, MachineReviewsComponent],
  imports: [
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    AzureMapsModule,
    SearchResultsModule,
    RubblSharedModule,
    CartModule,
    NgxSkeletonLoaderModule,
    CoreModule,
    InventoryModule,
    MarketingModule,
    AccountModule,
    LayoutModule,
  ],
  providers: [AddressPipe, MachineDetailsResolverService],
})
export class MachineDetailsModule {}
